import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
  ResponsiveContainer, ReferenceLine,
} from 'recharts';
import { COLORS } from '../data/constants';

// Hardcoded price data from CSV starting at 10:07 AM EST
const RAW_DATA = [
  [1762355226,'10:07',37.50],[1762355286,'10:08',37.50],[1762355347,'10:09',37.50],
  [1762355407,'10:10',37.50],[1762355466,'10:11',37.50],[1762355526,'10:12',37.50],
  [1762355586,'10:13',40.00],[1762355646,'10:14',41.00],[1762355705,'10:15',40.50],
  [1762355766,'10:16',40.00],[1762355825,'10:17',40.00],[1762355885,'10:18',39.50],
  [1762355947,'10:19',39.50],[1762356005,'10:20',40.00],[1762356065,'10:21',40.00],
  [1762356125,'10:22',40.00],[1762356185,'10:23',39.00],[1762356245,'10:24',39.00],
  [1762356305,'10:25',39.00],[1762356369,'10:26',39.00],[1762356425,'10:27',39.50],
  [1762356485,'10:28',41.50],[1762356545,'10:29',40.50],[1762356608,'10:30',40.50],
  [1762356665,'10:31',39.50],[1762356725,'10:32',39.50],[1762356785,'10:33',39.50],
  [1762356845,'10:34',39.50],[1762356905,'10:35',39.50],[1762356965,'10:36',39.50],
  [1762357025,'10:37',39.50],[1762357085,'10:38',39.50],[1762357145,'10:39',39.50],
  [1762357205,'10:40',39.50],[1762357265,'10:41',39.00],[1762357325,'10:42',39.00],
  [1762357385,'10:43',39.00],[1762357445,'10:44',38.50],[1762357505,'10:45',38.00],
  [1762357565,'10:46',37.50],[1762357625,'10:47',37.50],[1762357685,'10:48',37.50],
  [1762357745,'10:49',37.50],[1762357805,'10:50',37.50],[1762357865,'10:51',37.50],
  [1762357929,'10:52',37.50],[1762357985,'10:53',37.00],[1762358045,'10:54',37.00],
  [1762358106,'10:55',37.00],[1762358165,'10:56',37.00],[1762358225,'10:57',36.00],
  [1762358285,'10:58',34.00],[1762358345,'10:59',29.50],
  [1762358413,'11:00',27.00],[1762358465,'11:01',27.00],[1762358525,'11:02',27.00],
  [1762358585,'11:03',27.00],[1762358645,'11:04',27.00],[1762358705,'11:05',27.00],
  [1762358765,'11:06',27.00],[1762358825,'11:07',27.00],[1762358885,'11:08',29.00],
  [1762358945,'11:09',29.00],[1762359005,'11:10',29.50],[1762359065,'11:11',29.50],
  [1762359125,'11:12',29.50],[1762359185,'11:13',29.50],[1762359245,'11:14',29.50],
  [1762359305,'11:15',29.50],[1762359365,'11:16',29.50],[1762359425,'11:17',29.50],
  [1762359485,'11:18',28.00],[1762359545,'11:19',27.50],[1762359605,'11:20',28.00],
  [1762359665,'11:21',28.00],[1762359725,'11:22',28.50],[1762359785,'11:23',28.50],
  [1762359845,'11:24',28.00],[1762359905,'11:25',27.50],[1762359967,'11:26',27.50],
  [1762360027,'11:27',27.50],[1762360085,'11:28',27.00],[1762360145,'11:29',25.50],
  [1762360208,'11:30',26.50],[1762360265,'11:31',26.50],[1762360325,'11:32',24.50],
  [1762360385,'11:33',23.00],[1762360445,'11:34',21.50],[1762360505,'11:35',17.50],
  [1762360565,'11:36',17.50],[1762360625,'11:37',22.00],[1762360685,'11:38',24.50],
  [1762360745,'11:39',24.50],[1762360805,'11:40',24.50],[1762360865,'11:41',23.00],
  [1762360925,'11:42',21.00],[1762360985,'11:43',22.50],[1762361046,'11:44',24.50],
  [1762361105,'11:45',24.50],[1762361165,'11:46',25.00],[1762361225,'11:47',25.00],
  [1762361285,'11:48',26.50],[1762361345,'11:49',26.50],[1762361406,'11:50',25.50],
  [1762361465,'11:51',25.00],[1762361529,'11:52',20.00],[1762361585,'11:53',20.50],
  [1762361645,'11:54',20.50],[1762361706,'11:55',22.50],[1762361765,'11:56',22.00],
  [1762361825,'11:57',22.00],[1762361885,'11:58',22.00],[1762361945,'11:59',21.50],
  [1762362013,'12:00',22.50],[1762362065,'12:01',23.50],[1762362125,'12:02',24.50],
  [1762362185,'12:03',24.50],[1762362245,'12:04',24.00],[1762362306,'12:05',24.00],
  [1762362365,'12:06',24.00],[1762362425,'12:07',23.00],[1762362485,'12:08',21.50],
  [1762362545,'12:09',22.00],[1762362605,'12:10',22.00],[1762362665,'12:11',22.50],
  [1762362725,'12:12',21.50],[1762362785,'12:13',21.50],[1762362845,'12:14',22.00],
  [1762362905,'12:15',22.00],[1762362965,'12:16',22.00],[1762363025,'12:17',21.50],
  [1762363085,'12:18',21.50],[1762363145,'12:19',22.00],[1762363206,'12:20',23.50],
  [1762363265,'12:21',23.00],[1762363325,'12:22',23.00],[1762363385,'12:23',23.00],
  [1762363445,'12:24',23.00],[1762363506,'12:25',23.00],[1762363570,'12:26',23.00],
  [1762363625,'12:27',23.00],[1762363685,'12:28',23.00],[1762363745,'12:29',23.00],
  [1762363808,'12:30',23.00],[1762363865,'12:31',21.50],[1762363925,'12:32',28.00],
  [1762363985,'12:33',25.00],[1762364045,'12:34',26.50],[1762364105,'12:35',27.50],
  [1762364165,'12:36',25.00],
];

const chartData = RAW_DATA.map(([ts, time, prob]) => ({
  time,
  probability: prob,
  timestamp: ts,
}));

// Vertical marker lines (unix timestamps computed from 10:00:00 EST = 1762354800)
const BASE = 1762354800; // 10:00:00 EST on 11/05/2025
const MARKERS = [
  { ts: BASE + 12 * 60 + 30, color: '#00d395', label: '10:12:30' },  // green
  { ts: BASE + 58 * 60 + 30, color: '#ff4976', label: '10:58:30' },  // red
  { ts: BASE + 94 * 60,      color: '#ff4976', label: '11:34' },     // red
  { ts: BASE + 111 * 60 + 15, color: '#ff4976', label: '11:51:15' }, // red
  { ts: BASE + 151 * 60 + 30, color: '#00d395', label: '12:31:30' }, // green
];

// Y-axis: 5% increments covering the data range
const probs = chartData.map(d => d.probability);
const yMin = Math.max(0, Math.floor(Math.min(...probs) / 5) * 5 - 5);
const yMax = Math.min(100, Math.ceil(Math.max(...probs) / 5) * 5 + 5);
const yTicks = [];
for (let v = yMin; v <= yMax; v += 5) yTicks.push(v);

// X-axis domain
const xMin = chartData[0].timestamp;
const xMax = chartData[chartData.length - 1].timestamp;

// Generate tick values at round 15-minute intervals
const xTicks = [];
const firstTick = Math.ceil(xMin / 900) * 900; // next 15-min boundary
for (let t = firstTick; t <= xMax; t += 900) xTicks.push(t);

const formatTime = (ts) => {
  const d = new Date(ts * 1000);
  const h = d.getUTCHours() - 5; // UTC to EST (Nov = EST not EDT... but data is consistent)
  const m = d.getUTCMinutes();
  const hour = ((h % 12) || 12);
  const ampm = h < 12 ? 'AM' : 'PM';
  return `${hour}:${String(m).padStart(2, '0')} ${ampm}`;
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const d = payload[0].payload;
    return (
      <div style={styles.tooltip}>
        <div style={styles.tooltipProb}>{d.probability}%</div>
        <div style={styles.tooltipTime}>{d.time} EST</div>
      </div>
    );
  }
  return null;
};

const GraphicsPage = () => {
  const firstProb = chartData[0].probability;
  const lastProb = chartData[chartData.length - 1].probability;

  return (
    <div className="graphics-page" style={styles.page}>
      <div className="graphics-card" style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <h2 className="graphics-question" style={styles.question}>
            Will the Supreme Court rule in favor of Trump's tariffs?
          </h2>
          <div className="graphics-meta" style={styles.meta}>
            <span style={styles.probRange}>
              {firstProb}% &rarr; {lastProb}%
            </span>
            <span className="graphics-time-range" style={styles.timeRange}>10:07 AM – 12:36 PM EST</span>
          </div>
        </div>

        {/* Chart */}
        <div className="graphics-chart" style={styles.chartArea}>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart
              data={chartData}
              margin={{ top: 8, right: 16, left: -8, bottom: 4 }}
            >
              <CartesianGrid
                horizontal={true}
                vertical={false}
                strokeDasharray="4 4"
                stroke="rgba(255,255,255,0.08)"
              />
              <XAxis
                dataKey="timestamp"
                type="number"
                domain={[xMin, xMax]}
                ticks={xTicks}
                tickFormatter={formatTime}
                axisLine={false}
                tickLine={false}
                tick={{ fill: '#6b7280', fontSize: 11 }}
              />
              <YAxis
                domain={[yMin, yMax]}
                ticks={yTicks}
                axisLine={false}
                tickLine={false}
                tick={{ fill: '#6b7280', fontSize: 11 }}
                tickFormatter={(v) => `${v}%`}
                width={44}
              />
              <Tooltip
                content={<CustomTooltip />}
                cursor={{ stroke: 'rgba(255,255,255,0.15)', strokeWidth: 1 }}
              />

              {/* Vertical marker lines */}
              {MARKERS.map((m) => (
                <ReferenceLine
                  key={m.label}
                  x={m.ts}
                  stroke={m.color}
                  strokeWidth={1.5}
                  strokeDasharray="6 3"
                />
              ))}

              <Line
                type="monotone"
                dataKey="probability"
                stroke={COLORS.PRIMARY_BLUE}
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 4, fill: COLORS.PRIMARY_BLUE, strokeWidth: 0 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#0f1319',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
  },
  card: {
    backgroundColor: '#141722',
    borderRadius: '12px',
    border: '1px solid rgba(255,255,255,0.06)',
    padding: '28px',
    maxWidth: '900px',
    width: '100%',
  },
  header: {
    marginBottom: '20px',
  },
  question: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#fff',
    margin: '0 0 8px 0',
    lineHeight: 1.3,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    letterSpacing: '-0.2px',
  },
  meta: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '12px',
  },
  probRange: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#d1d5db',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  timeRange: {
    fontSize: '12px',
    color: '#6b7280',
    marginLeft: 'auto',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  chartArea: {},
  tooltip: {
    background: '#1e2235',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '8px',
    padding: '8px 12px',
  },
  tooltipProb: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#fff',
    lineHeight: 1,
  },
  tooltipTime: {
    fontSize: '12px',
    color: '#6b7280',
    marginTop: '4px',
  },
};

export default GraphicsPage;
